/**
 * Maps Bullhorn JobSubmission status strings → Werftools pipeline stage names (same as pipeline sync).
 */
export const BULLHORN_SUBMISSION_STATUS_TO_LOCAL: Record<string, string> = {
  New: 'Shortlist',
  'New Lead': 'Shortlist',
  'New Submission': 'Shortlist',
  Submitted: 'Shortlist',
  Reviewed: 'Shortlist',
  'Op shortlist': 'Shortlist',
  Shortlisted: 'Shortlist',
  'Talent pool': 'Shortlist',
  'Kandidaat geïnteresseerd': 'Shortlist',
  Sendout: 'Voorgesteld',
  Presented: 'Voorgesteld',
  'Client Submission': 'Voorgesteld',
  Voorgesteld: 'Voorgesteld',
  Voorstellen: 'Voorgesteld',
  'Warme stoel': 'Voorgesteld',
  'Positief klant': 'Voorgesteld',
  Interview: 'Gesprek',
  Gesprek: 'Gesprek',
  '1e Gesprek': 'Gesprek',
  '1e Gesprek(zonder mail)': 'Gesprek',
  '2e Gesprek': 'Gesprek',
  'Interview bevestiging mailen': 'Gesprek',
  'Interview Bevestiging Mailen': 'Gesprek',
  'Bevestiging niet mailen': 'Gesprek',
  'Bevestiging Niet Mailen': 'Gesprek',
  'Client Interview': 'Gesprek',
  'Second Interview': 'Gesprek',
  'Background Check': 'Gesprek',
  'Hiring Manager Sendout': 'Gesprek',
  Offer: 'Aanbod',
  Offers: 'Aanbod',
  'Offer Sent': 'Aanbod',
  'Offer Extended': 'Aanbod',
  'Offer Accepted': 'Aanbod',
  Placed: 'Plaatsing',
  Hired: 'Plaatsing',
  Plaatsing: 'Plaatsing',
  Geplaatst: 'Plaatsing',
  Rejected: 'Rejected',
  Declined: 'Rejected',
  Withdrawn: 'Rejected',
  'No Show': 'Rejected',
  Afgewezen: 'Rejected',
  'Afgewezen door opdrachtgever': 'Rejected',
  'Automatisch afwijzen': 'Rejected',
  'Geen feedback klant': 'Rejected',
  'Negatief klant': 'Rejected',
  'Niet voorgesteld': 'Rejected',
  'Nog af te wijzen': 'Rejected',
  'Offer Rejected By Candidate': 'Rejected',
  'Rejected By Client': 'Rejected',
  'Kandidaat teruggetrokken': 'Rejected',
  'opdracht ingetrokken': 'Rejected',
};

export function mapBullhornSubmissionStatusToLocalStage(raw: string | null | undefined): string {
  const s = raw == null ? '' : String(raw).trim();
  if (!s) return 'Shortlist';
  return (
    BULLHORN_SUBMISSION_STATUS_TO_LOCAL[s] ||
    BULLHORN_SUBMISSION_STATUS_TO_LOCAL[s.replace(/\s+/g, ' ')] ||
    s
  );
}
